import { Action } from 'redux';

import { SpaceInfo } from '../state/SpaceInfo';
import { ReorderItem } from './AppActionTypes';
import { isActionFactory } from './isActionFactory';

export interface ReorderItemAction extends Action {
  fromIndex: number;
  indexToMoveAfter: number;
  spaceInfo: SpaceInfo;
}

export function reorderItem(fromIndex: number, indexToMoveAfter: number, spaceInfo: SpaceInfo): ReorderItemAction {
  return {
    type: ReorderItem,
    spaceInfo,
    fromIndex,
    indexToMoveAfter: indexToMoveAfter,
  };
}

export const isReorderItemAction = isActionFactory<ReorderItemAction>(ReorderItem);
